import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// "ResizeObserver loop completed with undelivered notifications" is a benign
// browser notice (not an app error), but the dev error overlay surfaces it as a
// crash. Defer ResizeObserver callbacks to the next animation frame so the
// synchronous resize loop that triggers the notice never forms.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// Belt-and-suspenders: also swallow the specific message if it still surfaces.
const RESIZE_OBSERVER_MSG = "ResizeObserver loop";
window.addEventListener(
  "error",
  (e) => {
    if (e?.message && e.message.includes(RESIZE_OBSERVER_MSG)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
